import { render, staticRenderFns } from "./ExternalValidationForm.vue?vue&type=template&id=63901152&scoped=true&"
import script from "./ExternalValidationForm.vue?vue&type=script&lang=ts&"
export * from "./ExternalValidationForm.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalValidationForm.vue?vue&type=style&index=0&id=63901152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63901152",
  null
  
)

export default component.exports